var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowAttention01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "160px",
    height: "160px",
    viewBox: "33.049 76.08 160 160",
    enableBackground: "new 33.049 76.08 160 160",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFCB41",
    d: "M113.049,76.08c-44.183,0-80,35.816-80,80c0,44.183,35.817,80,80,80c44.182,0,80-35.817,80-80 C193.049,111.896,157.23,76.08,113.049,76.08z M113.049,216.046c-33.119,0-59.967-26.848-59.967-59.967 s26.848-59.967,59.967-59.967c33.118,0,59.967,26.848,59.967,59.967S146.167,216.046,113.049,216.046z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F03",
    d: "M104.627,143.675c-0.404-6.801-0.932-13.598-1.178-20.403c-0.225-6.224,3.779-10.828,9.219-11.002 c5.928-0.192,10.223,4.046,9.98,10.46c-0.4,10.574-1.158,21.137-1.744,31.703c-0.202,3.643-0.348,7.289-0.5,10.936 c-0.206,4.908-2.914,7.903-7.207,7.947c-4.35,0.045-7.059-2.803-7.344-7.775c-0.416-7.287-0.806-14.576-1.207-21.865 C104.641,143.675,104.633,143.675,104.627,143.675z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6F03",
    d: "M103.561,189.78c-0.072-5.241,4.131-9.61,9.357-9.728c5.239-0.115,9.475,4.035,9.617,9.424 c0.135,5.179-4.166,9.691-9.317,9.779C108.105,199.343,103.634,194.957,103.561,189.78z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowAttention01);
export default __webpack_public_path__ + "static/media/window_attention-01.9d37b2050c7e6cf95f0c894bfbd4e0b7.svg";
export { ForwardRef as ReactComponent };